export const axiosData = {
  getStorePermission: { url: '/api/permissions/:id', method: 'get' },
  setStorePermission: { url: '/api/permissions/:id', method: 'put' },
  deleteStorePermission: { url: '/api/permissions/:id', method: 'delete' },
};
